export const STATUS_OPTIONS = [
  { label: 'All Statuses', value: '' },
  { label: 'Active', value: 'Active' },
  { label: 'Banned', value: 'Banned' },
  { label: 'Suspended', value: 'Suspended' },
];

export const ROLE_OPTIONS = [
  { label: 'All Roles', value: '' },
  { label: 'Member', value: 'member' },
  { label: 'Kid', value: 'kid' },
  { label: 'Manager', value: 'manager' },
];

export const BILLING_OPTIONS = [
  { label: 'Billing Cycle', value: '' },
  { label: 'Monthly', value: 'monthly' },
  { label: 'Quarterly', value: 'quarterly' },
  { label: 'Yearly', value: 'yearly' },
];

export const SORT_OPTIONS = [
  { value: 'createdAt', label: 'Join Date' },
  { value: 'name', label: 'Name' },
  { value: 'email', label: 'Email' },
  { value: 'status', label: 'Status' },
  { value: 'subscriptionDate', label: 'Subs Date' },
  { value: 'renewalDate', label: 'Renewal Date' },
  { value: 'amount', label: 'Amount' }
];

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];